import { CALENDAR_VIEWS } from "@/constants/calendar";
import { faSort } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { FC } from "react";
import { Dropdown } from "react-bootstrap";
import Flex from "./Flex";
import { ISelectOption } from "@/interfaces/Select";

interface DropdownItemFilterProps {
  isActive: boolean;
  children: JSX.Element;
  onClick: () => void;
}

const DropdownItemFilter: FC<DropdownItemFilterProps> = ({
  isActive,
  children,
  onClick,
}) => {
  return (
    <Dropdown.Item
      as={Flex}
      justifyContent="between"
      className={classNames("cursor-pointer text-capitalize", {
        active: isActive,
      })}
      onClick={onClick}
    >
      <>{children}</>
      {isActive && <FontAwesomeIcon icon="check" transform="down-4 shrink-4" />}
    </Dropdown.Item>
  );
};

interface DropdownFilterProps {
  currentView: ISelectOption<string>;
  setCurrentView: (value: ISelectOption<string>) => void;
}

const DropdownCalendarFilter: FC<DropdownFilterProps> = ({
  currentView,
  setCurrentView,
}) => {
  return (
    <Dropdown className="font-sans-serif me-2">
      <Dropdown.Toggle
        variant="nolina-default"
        className="text-600 dropdown-caret-none"
        size="sm"
      >
        {currentView && <span className="me-2">{currentView.label}</span>}
        <FontAwesomeIcon icon={faSort} />
      </Dropdown.Toggle>

      <Dropdown.Menu className="border py-2">
        {CALENDAR_VIEWS.map((filter, index) => (
          <DropdownItemFilter
            isActive={currentView.value === filter.value}
            key={index}
            onClick={() => setCurrentView(filter)}
          >
            <span>{filter.label}</span>
          </DropdownItemFilter>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DropdownCalendarFilter;
